import { Link, useParams, useSearchParams } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { user } from "../../routes/route";
import { IconButton, Paper, useScrollTrigger } from "@mui/material";
import profile from "../../Assests/image/profile_not_found.png";
import CommonListing, {
  CommonListingName,
} from "../../components/commonListing/CommonListing";
import { Navigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useEffect, useState } from "react";
import RemedyTable from "./viewTable/RemedyTable";
import ConsultantHistoryTable from "./viewTable/ConsultantHistoryTable";
import ModalBox from "../../components/modal/ModalBox";
import {
  getSelectedUserDetail,
  getUserHistoryApi,
  updateUserWallet,
} from "../../services/userManagement";
import scrollToUp from "../../utils/scrollToUp";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { toastMessage } from "../../utils/toastMessage";
import { calculateAge, dateFormat, dobFormat } from "../../utils/dateFormat";
import UserStatus from "./UserStatus";
import { CapitalizeFirstWord } from "../../utils/CapitalizeFirstWord";
import { fatchCategoryApi } from "../../services/categoryManagement";
import UserHistory from "./UserHistory";
import { CustomTab, CustomTabs } from "../../components/tabs/Tabs";
import RemedyListing from "./RemedyListing";
import UserConsultantListing from "./UserConsultantListing";
import UserTransactionListing from "./UserTransactionListing";
import UserSupportListing from "./UserSupportListing";
import common from "../../routes/common";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import useDebounce from "../../hooks/useDebounce";
import { useCreatePortal } from "../../hooks/useCreatePortal";
import { allowNumber } from "../../utils/regex";
import { IoSearch } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { sendMessageApi } from "../../services/supportManagement";
import { CommonSelect, Input, TextArea } from "../../components/Form";
import useButtonLoader from "../../hooks/UseButtonLoader";
import NumericalAnalytics from "./NumericalAnalytics";
import axios from "axios";
import ResponsiveDetailPage from "../../components/ResponsiveDetailPage";
import ResponsiveProfileSection from "../../components/ResponsiveProfileSection";
import ResponsiveWalletSection from "../../components/ResponsiveWalletSection";
import ResponsiveTabs from "../../components/ResponsiveTabs";
import useResponsive from "../../hooks/useResponsive";
const { USER_MANAGEMENT } = user;

const tabData = [
  {
    id: "REMEDY",
    title: "Remedy",
    eventKey: "REMEDY",
  },
  {
    id: "CONSULTANT",
    title: "Consultant",
    eventKey: "CONSULTANT",
  },
  {
    id: "TRANSACTION",
    title: "Transaction",
    eventKey: "TRANSACTION",
  },
  {
    id: "SUPPORT",
    title: "Customer Consultant User Support",
    eventKey: "SUPPORT",
  },
];

const UserDetail = () => {
  const navigate = useNavigate();
  const { id: userId } = useParams();
  const { isMobile, isTablet } = useResponsive();
  
  // handle all state
  const [userDetail, setUserDetail] = useState("");
  const [orderList, setOrderList] = useState([]);
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  let type = searchParam.get("type") || "CONSULTANT";
  const [total, setTotal] = useState(null);
  const [wallet, setWallet] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [key, setKey] = useState("CONSULTANT");
  const [blockUserModel, setBlockUserModel] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [statusId, setStatusId] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [walletActionState, openWalletActionMdl, closeWalletActionMdl, WalletActionModal] = useCreatePortal()
  const [walletAmountInput, setWalletAmountInput] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [inputField, setInputField] = useState({});
  const [buttonref, buttonLoader] = useButtonLoader("Send");

  const [search, setSearch] = useState(
    getLocalStorage("useDetailList", "search") || ""
  );
  const debounceValue = useDebounce(search || "", 300);

  // Consultation history filters (same as Consultant Detail)
  const [historyStartDate, setHistoryStartDate] = useState("");
  const [historyEndDate, setHistoryEndDate] = useState("");
  const [historyGender, setHistoryGender] = useState("");
  const [historyConsultationType, setHistoryConsultationType] = useState("");
  const [historyUserProblem, setHistoryUserProblem] = useState("");
  const [historyStatus, setHistoryStatus] = useState("");
  const [historyConsultationOrder, setHistoryConsultationOrder] = useState("");
  const [historyUserTotalConsultations, setHistoryUserTotalConsultations] = useState("");
  const [totalConsultationsForUser, setTotalConsultationsForUser] = useState(null);

  useEffect(() => {
    setLocalStorage("useDetailList", "search", search);
  }, [search]);

  // handle all hooks
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  // handle all function

  // const blockUserFunction = () => {
  //   setBlockUserModel(true)
  // }

  const statusUpdateHandler = (id, status) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
  };

  const closeModel = () => {
    setStatusModal(false);
    setStatusValue("");
    setStatusId("");
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setInputField({ ...inputField, [name]: value });
  };
  const getSelectedUserDetailHandler = async (userId) => {
    try {
      showLoader();
      const sendData = {
        userId: userId,
      };
      const { data } = await getSelectedUserDetail(sendData);
      console.log('datauserdetails------>', JSON.stringify(data))
      if (data?.code === 200) {
        setUserDetail(data?.result?.details[0]);
        setWallet(data?.result?.wallet);
        scrollToUp();
      } else {
        setUserDetail("");
        toastMessage(data?.message, "error", "categoryList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // Category List
  const fetchCategoryHandler = async () => {
    try {
      setCategoryList([]);
      showLoader();
      const { data } = await fatchCategoryApi();
      if (data.code === 200) {
        setCategoryList(data?.result?.categoryList || []);
        // setTotal(res?.data?.data?.pagination?.totalItems || 0)
      } else {
        setCategoryList([]);
        toastMessage(data.message, "error", "categoryList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };


  const userTypeHandler = (nextType) => {
    const normalizedType = (nextType || "").toString().trim().toUpperCase();
    const validTypes = ["CONSULTANT", "REMEDY", "TRANSACTION", "SUPPORT"];
    const safeType = validTypes.includes(normalizedType) ? normalizedType : "CONSULTANT";
    const nextParams = new URLSearchParams(searchParam);
    nextParams.set("type", safeType);
    nextParams.delete("page");
    setSearchParam(nextParams);
  };

  // Fetch Consultant order history
  const fetchUserOrderList = async () => {
    const historyTypes = ["CONSULTANT", "REMEDY"];
    if (!historyTypes.includes(type)) {
      setOrderList([]);
      setTotal(0);
      if (type !== "CONSULTANT") setTotalConsultationsForUser(null);
      return;
    }

    try {
      setOrderList([]);
      showLoader();
      const sendData = {
        page: activePage,
        limit: 10,
        userId: userId,
        type: type,
      };
      if (type === "CONSULTANT") {
        if (debounceValue) sendData.search = search;
        if (historyStartDate) sendData.startDate = historyStartDate;
        if (historyEndDate) sendData.endDate = historyEndDate;
        if (historyGender) sendData.gender = historyGender;
        if (historyConsultationType) sendData.consultationType = historyConsultationType;
        if (historyUserProblem) sendData.userProblem = historyUserProblem;
        if (historyStatus) sendData.status = historyStatus;
        if (historyConsultationOrder) sendData.consultationOrder = historyConsultationOrder;
        if (historyUserTotalConsultations) sendData.userTotalConsultations = historyUserTotalConsultations;
      }
      const { data } = await getUserHistoryApi(sendData);
      if (data.code === 200) {
        setOrderList(data?.result?.list || []);
        setTotal(data?.result?.total || 0);
        if (type === "CONSULTANT" && data?.result?.totalConsultationsForUser != null) {
          setTotalConsultationsForUser(data.result.totalConsultationsForUser);
        }
      } else {
        setOrderList([]);
        setTotal(0);
        if (type === "CONSULTANT") setTotalConsultationsForUser(null);
        toastMessage(data.message, "error", "orderList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  console.log("list====", orderList)

  useEffect(() => {
    if (userId) {
      getSelectedUserDetailHandler(userId);
    }
  }, [userId]);

  useEffect(() => {
    fetchCategoryHandler();
  }, []);

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParam.delete("page");
    }

    setSearchParam(searchParam);
    fetchUserOrderList();
  }, [
    searchParam,
    debounceValue,
    historyStartDate,
    historyEndDate,
    historyGender,
    historyConsultationType,
    historyUserProblem,
    historyStatus,
    historyConsultationOrder,
    historyUserTotalConsultations,
  ]);

  // console.log(orderList, "orderList");

  const executeWalletAction = async () => {
    if (!walletAmountInput || Number(walletAmountInput) <= 0) {
      toastMessage('Please enter valid amount!', "error", "wallet_actions");
      return;
    }
    try {
      showLoader();
      const data = {
        userId: userId,
        amount: Number(walletAmountInput),
        action: walletActionState
      };
      let res;
      if (walletActionState == 'wallet_deduct') {
        res = await updateUserWallet(data);
      } else {
        res = await updateUserWallet(data);
      }
      if (res.data.code === 200) {
        toastMessage(res.data.message, "success", walletActionState == 'wallet_deduct' ? "deductionAmount" : "refundedAmount");
        setWalletAmountInput("");
        closeWalletActionMdl();
      } else {
        toastMessage(res.data.message, "error", walletActionState == 'wallet_deduct' ? "deductionAmount" : 'refundedAmount');
      }
      hideLoader();
    } catch (e) {
      hideLoader();
    }
  };

  const walletActionsHandler = () => {
    executeWalletAction();
  };
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      navigate(-1);
    } else {
      navigate("/default-route");
    }
  };
  const SendMessage = async () => {
    const formData = new FormData();
    formData.append("supportType", "ADMIN");
    formData.append("userId", userId);
    formData.append("userType", "user");
    formData.append("title", inputField?.title);
    formData.append("description", inputField?.message);
    try {
      buttonLoader(true);
      const { data } = await sendMessageApi(formData);
      if (data.code === 200) {
        toastMessage(data.message, "success", "SendMessage");
      } else {
        toastMessage(data.message, "error", "SendMessage");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      buttonLoader(false);
    }
  }
  

  // Prepare data for responsive components
  const profileData = [
    [
      { label: "User ID", value: userDetail.userId },
      { label: "User Name", value: userDetail.name },
      { label: "Email", value: userDetail.email },
      { 
        label: "Mobile", 
        value: userDetail.phone ? (
          <a href={`tel:${userDetail.phone}`} style={{ color: '#FF8989', textDecoration: 'none' }}>
            {userDetail.phone}
          </a>
        ) : "---"
      },
      { label: "Age", value: userDetail?.dob ? calculateAge(userDetail.dob) + ' Years' : "---" }
    ],
    [
      { label: "Gender", value: userDetail.gender ? CapitalizeFirstWord(userDetail.gender) : "---" },
      { label: "DOB", value: userDetail?.dob ? dobFormat(userDetail.dob) : "---" },
      { label: "Register Date", value: userDetail.createdAt ? dateFormat(userDetail.createdAt) : "---" },
      { label: "Address", value: `${userDetail.address || ""} ${userDetail.city || ""} ${userDetail.state || ""}`.trim() || "---" }
    ]
  ];

  const walletData = [
    { label: "Total Savings", value: `₹ ${(Number(wallet?.savedCoins) || 0).toFixed(2)}` },
    { label: "Wallet", value: `₹ ${(userDetail?.wallet ? Number(userDetail.wallet).toFixed(2) : 0)}` }
  ];

  const headerActions = [
    {
      label: "Send Message",
      onClick: () => setOpenModal(true),
      className: "btn_size"
    },
    {
      label: `${userDetail.status ? "Block" : "Unblock"} User`,
      onClick: () => statusUpdateHandler(userId, userDetail.status),
      className: "btn_size"
    },
    {
      label: "Wallet Deduct",
      onClick: () => {
        setWalletAmountInput("");
        openWalletActionMdl('wallet_deduct');
      },
      className: "btn_size"
    },
    {
      label: "Wallet Refund",
      onClick: () => {
        setWalletAmountInput("");
        openWalletActionMdl('wallet_refund');
      },
      className: "btn_size"
    }
  ];

  console.log("UserIdd===>", userId)
  return (
    <>
      <WalletActionModal>
        <div style={{ backgroundColor: '#fff', padding: '20px' }}>
          <div className="form-group mb-2">
            <Input
              type="number"
              name="heading"
              value={walletAmountInput}
              required
              onChange={(e) => {
                setWalletAmountInput(e.target.value);
              }}
              placeholder="Amount"
              className={`form-control mb-2`}
              label={walletActionState == 'wallet_deduct' ? "Deduct Amount" : "Refund Amount"}
              autoFocus
            />
            <div>
              <button
                className="btn_size"
                onClick={walletActionsHandler}
              >
                Yes
              </button>
              <button
                className="btn_size ms-1"
                onClick={() => {
                  setWalletAmountInput("");
                  closeWalletActionMdl();
                }}
              >
                Discard
              </button>
            </div>
          </div>
        </div>
      </WalletActionModal>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <ResponsiveDetailPage
            title="User Management"
            onBack={handleBack}
            actions={headerActions}
          >
            {/* Profile Section */}
            <ResponsiveProfileSection
              profileImage={userDetail.profileImage || profile}
              profileData={profileData}
            />

            {/* Wallet Section */}
           

            {userDetail.problems?.length > 0 && (
              <div className="mt-4">
                <h5>Problems</h5>
                <ul>
                  {userDetail.problems.map((p, idx) => (
                    <li key={idx}>{p}</li>
                  ))}
                </ul>
              </div>
            )}
             <ResponsiveWalletSection
              walletData={walletData}
            />
            <div className="mt-4">
              <NumericalAnalytics />
            </div>
            
            <div className="tab_table w-500">
              <div className="FilterBox FilterArea" style={{ flexDirection: "row", flexWrap: "wrap", gap: "15px", alignItems: "center" }}>
                <div className="form-group search_lg_size userSearch" style={{ minWidth: "200px", flex: "1 1 auto" }}>
                  {type === "CONSULTANT" && (
                    <>
                      <input
                        type="search"
                        className={`form-control ${search ? "active" : ""}`}
                        placeholder="Search by User ID, User Name..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ "--color": "#FF8989" }}
                      />
                      <span className="user_search_icon">
                        <IoSearch />
                      </span>
                    </>
                  )}
                </div>
                {type === "CONSULTANT" && (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>User Gender</label>
                      <select
                        className="form-control"
                        value={historyGender}
                        onChange={(e) => setHistoryGender(e.target.value)}
                        style={{ minWidth: "120px" }}
                      >
                        <option value="">All</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>Type of Consultation</label>
                      <select
                        className="form-control"
                        value={historyConsultationType}
                        onChange={(e) => setHistoryConsultationType(e.target.value)}
                        style={{ minWidth: "140px" }}
                      >
                        <option value="">All</option>
                        <option value="audio">Audio</option>
                        <option value="chat">Chat</option>
                        <option value="video">Video</option>
                      </select>
                    </div>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>User's Problem</label>
                      <select
                        className="form-control"
                        value={historyUserProblem}
                        onChange={(e) => setHistoryUserProblem(e.target.value)}
                        style={{ minWidth: "140px" }}
                      >
                        <option value="">All</option>
                        <option value="Family">Family</option>
                        <option value="Finance">Finance</option>
                        <option value="Career">Career</option>
                        <option value="Marriage">Marriage</option>
                        <option value="Relationship">Relationship</option>
                        <option value="Health">Health</option>
                        <option value="Exam">Exam</option>
                        <option value="Depression">Depression</option>
                      </select>
                    </div>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>Status</label>
                      <select
                        className="form-control"
                        value={historyStatus}
                        onChange={(e) => setHistoryStatus(e.target.value)}
                        style={{ minWidth: "120px" }}
                      >
                        <option value="">All</option>
                        <option value="completed">Completed</option>
                        <option value="canceled">Canceled</option>
                        <option value="missed">Missed</option>
                        <option value="progress">Progress</option>
                        <option value="waiting">Waiting</option>
                        <option value="blocked">Blocked</option>
                      </select>
                    </div>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>Consultation</label>
                      <select
                        className="form-control"
                        value={historyConsultationOrder}
                        onChange={(e) => setHistoryConsultationOrder(e.target.value)}
                        style={{ minWidth: "110px" }}
                      >
                        <option value="">All</option>
                        <option value="1">1st</option>
                        <option value="2">2nd</option>
                        <option value="3">3rd</option>
                        <option value="repeat">Repeat (4+)</option>
                      </select>
                    </div>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>User Total Consultations</label>
                      <select
                        className="form-control"
                        value={historyUserTotalConsultations}
                        onChange={(e) => setHistoryUserTotalConsultations(e.target.value)}
                        style={{ minWidth: "140px" }}
                      >
                        <option value="">All</option>
                        {Array.from({ length: 20 }, (_, i) => i + 1).map((n) => (
                          <option key={n} value={String(n)}>{n}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={historyStartDate}
                        onChange={(e) => setHistoryStartDate(e.target.value)}
                        style={{ minWidth: "140px" }}
                      />
                    </div>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={historyEndDate}
                        onChange={(e) => setHistoryEndDate(e.target.value)}
                        style={{ minWidth: "140px" }}
                      />
                    </div>
                    {(historyStartDate || historyEndDate || historyGender || historyConsultationType || historyUserProblem || historyStatus || historyConsultationOrder || historyUserTotalConsultations) && (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        style={{ alignSelf: "flex-end", marginBottom: "2px" }}
                        onClick={() => {
                          setHistoryStartDate("");
                          setHistoryEndDate("");
                          setHistoryGender("");
                          setHistoryConsultationType("");
                          setHistoryUserProblem("");
                          setHistoryStatus("");
                          setHistoryConsultationOrder("");
                          setHistoryUserTotalConsultations("");
                        }}
                      >
                        Clear
                      </button>
                    )}
                  </div>
                )}
                <ResponsiveTabs
                  value={type}
                  onChange={(e, section) => {
                    userTypeHandler(section);
                  }}
                  tabs={[
                    { value: "CONSULTANT", label: "Consultant" },
                    { value: "REMEDY", label: "Remedy" },
                    { value: "TRANSACTION", label: "Transaction" },
                    { value: "SUPPORT", label: "Customer Consultant User Support" }
                  ]}
                />
              </div>
            </div>

            {type === "CONSULTANT" && (
              <div className="mt-3">
             
                <UserConsultantListing
                  username={userDetail.name}
                  orderList={orderList}
                  total={total}
                  handlePageChange={handlePageChange}
                  activePage={activePage}
                  userId={userDetail?._id}
                  onRefreshConsultationList={fetchUserOrderList}
                />
              </div>
            )}

            {type === "REMEDY" && (
              <RemedyListing
                orderList={orderList}
                total={total}
                handlePageChange={handlePageChange}
                activePage={activePage}
              />
            )}
            {type === "TRANSACTION" && (
              <UserTransactionListing
                userId={userDetail?._id}
                username={userDetail.name}
              />
            )}
            {type === "SUPPORT" && (
              <UserSupportListing
                userId={userDetail?._id}
                username={userDetail?.name}
              />
            )}
          </ResponsiveDetailPage>
        </div>
      </div>
      {statusModal && (
        <UserStatus
          show={statusModal}
          close={closeModel}
          setUserDetail={setUserDetail}
          setListing={""}
          status={statusValue}
          id={statusId}
        />
      )}
      <ModalBox
        status={openModal}
        onClose={() => setOpenModal(false)}
        title={"Send Message"}
        size={"sm"}
        closeIcon
        custom
        customizedFooter={
          <div className="row">
            <div className="col-12">
              <div className="form-group mb-2">
                <Input
                  type="text"
                  name="title"
                  value={inputField?.title || ""}
                  // required
                  onChange={onChangeHandler}
                  placeholder="Title"
                  className={`form-control `}
                  label={"Title"}
                // error={!inputField?.title && error.title}
                />
              </div>
            </div>
            <div className="col-12">
              <div className="form-group mb-2">
                <TextArea
                  type="text"
                  name="message"
                  value={inputField?.message || ""}
                  required
                  onChange={onChangeHandler}
                  placeholder="message"
                  className={`form-control `}
                  label={"Message"}
                // error={!inputField?.message && error.message}
                // maxLength={30}
                />
              </div>
            </div>
            <div className="text-center">
              <button
                className="btn_size text-center"
                // onClick={SendMessage}
                onClick={() => {
                  SendMessage();
                  setOpenModal(false);
                }}
                ref={buttonref}
              >
                Send
              </button>
            </div>
          </div>
        }
      />
    </>
  );
};
export default UserDetail;
